import React, { createContext } from 'react';
import { TabSlug } from '../types/tab';
import { WorkflowIdEnum } from '../../../Workflow/api/useWorkflowDataQuery';

interface Context {
  clientId: string;
  tabSlug: TabSlug;
  isWorkflow: boolean;
  workflowId?: WorkflowIdEnum;
}

export const AccountsContext = createContext<Context | undefined>(undefined);

interface Props {
  value: Context;
}

export const AccountsProvider: React.FC<Props> = ({ children, value }) => (
  <AccountsContext.Provider value={value}>{children}</AccountsContext.Provider>
);
